import { POST } from "../API";

export const markMessageAsReadApi = (
  conversationId,
  messageId,
  onSuccess,
  onError
) => {
  const data = {};
  POST(
    `/api/v1/chat/conversations/${conversationId}/messages/${messageId}/read`,
    data,
    onSuccess,
    onError,
    true
  );
};

export const markMessagesAsReadApi = (
  conversationId,
  messageIds,
  onSuccess,
  onError
) => {
  const data = { message_ids: messageIds };
  POST(
    `/api/v1/chat/conversations/${conversationId}/messages/mark_as_read`,
    data,
    onSuccess,
    onError,
    true
  );
};
